@if (useCustomTimeInput) {
    <div class="input-group" (click)="onClick()">
        <input
            class="form-control pe-0"
            type="text"
            #textInput
            (focus)="onFocus()"
            (keydown)="$event.preventDefault()"
            [formControl]="timeInputControl"
            paceCoreValidationMessage
            [validation]="timeInputControl"
            [attr.aria-label]="ariaLabel"
        />
        <span class="input-group-text" (click)="textInput.focus()"><fa-icon [icon]="faClock"></fa-icon></span>
    </div>
}
@if (!useCustomTimeInput) {
    <div class="input-group">
        <input
            class="form-control pe-0"
            type="time"
            #timeInput
            (focus)="onFocus()"
            [formControl]="timeInputControl"
            paceCoreValidationMessage
            [validation]="timeInputControl"
            [attr.aria-label]="ariaLabel"
        />
        <span class="input-group-text" (click)="timeInput.focus()"><fa-icon [icon]="faClock"></fa-icon></span>
    </div>
}
